/*
* image 图片库
**/
import $axios from "@/service/httpServer";

//查询余额
export const queryBalance = p => $axios.post('/Web/Backend/Balance/queryBalance', p);

//查询充值套餐
export const listRechargeRules = p => $axios.post('/Web/Backend/Balance/listRechargeRules', p);

//生成支付二维码
export const getRechargeQrcode = p => $axios.post('/Web/Backend/Balance/getRechargeQrcode', p);

//查询充值记录
export const pageRecharge = p => $axios.post('/Web/Backend/Balance/pageRecharge', p);

//余额变动记录
export const pageBalanceHistory = p => $axios.post('/Web/Backend/Balance/pageBalanceHistory', p);